import { render, staticRenderFns } from "./BudgetsBusinessEntities.vue?vue&type=template&id=41b20632&"
import script from "./BudgetsBusinessEntities.vue?vue&type=script&lang=js&"
export * from "./BudgetsBusinessEntities.vue?vue&type=script&lang=js&"
import style0 from "./BudgetsBusinessEntities.vue?vue&type=style&index=0&id=41b20632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports